app.controller('dashboardDetailsOptionsCtrl', [
    '$scope', '$rootScope','detailIdGenerator',
    function ($scope, $rootScope,detailIdGenerator) {


    }
]);